var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"history"},[(_vm.privacyComponent)?_c(_vm.componentName,{tag:"component"}):(_vm.isLoaded)?_c('Empty'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }